(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-free-gift"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Load order across theme assets isn't guaranteed — this script
    // might execute before cart.js has defined window.CartGiftController.
    // If so, install a tiny stub that just queues calls; cart.js adopts
    // and replays everything queued here once it loads (see the
    // matching adoption logic at the top of cart.js). Idempotent:
    // whichever of this file / mystery-gift.js / cart.js runs first
    // "wins" and the others no-op against the same guard.
    if (!window.CartGiftController) {
      window.CartGiftController = {
        _isStub: true,
        _pendingRules: [],
        _pendingTiers: [],
        _pendingMutations: [],
        _lastState: null,
        registerRule: function (rule) { this._pendingRules.push(rule); },
        registerTier: function (tier) { this._pendingTiers.push(tier); },
        queueMutation: function (url, body) {
          var self = this;
          return new Promise(function (resolve, reject) {
            self._pendingMutations.push({ url: url, body: body, resolve: resolve, reject: reject });
          });
        },
      };
    }

    // NOTE: this script text is compiled once per SECTION TYPE by
    // Shopify, not once per instance — if a merchant adds this section
    // multiple times (e.g. three tiers), this code still runs exactly
    // once for the whole page. So instead of grabbing a single
    // hardcoded element, it scans for every ".cfg-wrapper" currently in
    // the DOM and sets each one up independently.
    var GIFT_PROPERTY = '_free_gift';

    var wrapperEls = Array.prototype.slice.call(document.querySelectorAll('.cfg-wrapper'));
    if (!wrapperEls.length) return;

    // Own gift line for this specific instance/tier (tagged with this
    // section's own id). Cross-tier priority — including against the
    // Mystery Gift selector, a totally different section type — is
    // resolved centrally via window.CartGiftController.currentBestTier,
    // not locally here; see registerTier in initSection below.
    function ownGiftLine(sec, cart) {
      return cart.items.find(function (item) {
        return item.properties && item.properties[GIFT_PROPERTY] === sec.sectionId;
      });
    }

    function initSection(wrapper) {
      var sec = {
        wrapper: wrapper,
        sectionId: wrapper.dataset.sectionId,
        minCartValueCents: parseInt(wrapper.dataset.minCartValue, 10) || 0,
        // 0 (or missing) means "no maximum" — gift stays available above the minimum
        maxCartValueCents: parseInt(wrapper.dataset.maxCartValue, 10) || 0,
        addBtn: wrapper.querySelector('.cfg-add-btn'),
        messageEl: wrapper.querySelector('.cfg-message'),
        radios: wrapper.querySelectorAll('.cfg-radio'),
        defaultLabel: wrapper.dataset.buttonLabel || 'Add Free Gift',
        selectedVariantId: null,
        busy: false,
      };

      sec.radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          sec.selectedVariantId = radio.value;
          wrapper.querySelectorAll('.cfg-card').forEach(function (c) {
            c.classList.remove('is-selected');
          });
          radio.closest('.cfg-card').classList.add('is-selected');
          sec.addBtn.disabled = false;
        });
      });

      function showMessage(text, isError) {
        sec.messageEl.textContent = text;
        sec.messageEl.hidden = false;
        sec.messageEl.style.color = isError ? '#c0392b' : '#1a7f37';
        setTimeout(function () {
          sec.messageEl.hidden = true;
        }, 4000);
      }

      // Called by CartGiftController after every cart state change.
      // Returns a mutation if THIS tier needs a correction, or null.
      // Never calls fetch itself — the controller queues and performs
      // the actual request, keeping every tier — this one, the other
      // Free Gift instances, AND the Mystery Gift selector — on one
      // shared, serialized queue.
      function evaluate(cart) {
        var giftLine = ownGiftLine(sec, cart);
        var best = window.CartGiftController.currentBestTier(cart);
        var isBest = !!(best && best.id === sec.sectionId);

        // A different tier currently outranks us (a higher Free Gift
        // range, or the Mystery Gift selector) — yield our own gift.
        if (!isBest && giftLine) {
          return { url: '/cart/change.js', body: { id: giftLine.key, quantity: 0 } };
        }

        // We ARE the current tier, but a leftover gift from a
        // different tier is still sitting in the cart — clear it so
        // the customer can pick from THIS tier instead of accumulating both.
        if (isBest && !giftLine) {
          var stale = window.CartGiftController.anyGiftLine(cart);
          if (stale) {
            return { url: '/cart/change.js', body: { id: stale.key, quantity: 0 } };
          }
        }

        return null;
      }

      function render(cart) {
        var giftLine = ownGiftLine(sec, cart);
        var best = window.CartGiftController.currentBestTier(cart);
        var isBest = !!(best && best.id === sec.sectionId);

        wrapper.style.display = isBest ? '' : 'none';
        if (!isBest) return;

        // If evaluate() above just queued a correction off this same
        // snapshot (a stale other-tier gift needs clearing first),
        // don't paint yet — the controller will call render() again
        // once it lands.
        if (!giftLine && window.CartGiftController.anyGiftLine(cart)) return;

        if (giftLine) {
          sec.addBtn.textContent = 'Free Gift Added ✓';
          sec.addBtn.disabled = true;
          sec.radios.forEach(function (r) {
            var isMatch = r.value === String(giftLine.variant_id);
            r.checked = isMatch;
            r.closest('.cfg-card').classList.toggle('is-selected', isMatch);
          });
        } else {
          sec.addBtn.textContent = sec.defaultLabel;
          sec.addBtn.disabled = !sec.selectedVariantId;
        }
      }

      sec.addBtn.addEventListener('click', function () {
        if (!sec.selectedVariantId || sec.busy) return; // local flag: just disables the button mid-click
        sec.busy = true;
        sec.addBtn.disabled = true;
        sec.addBtn.textContent = 'Adding...';

        var cart = window.CartGiftController._lastState;
        var existingGift = cart ? window.CartGiftController.anyGiftLine(cart) : null;

        var removeExisting = existingGift
          ? window.CartGiftController.queueMutation('/cart/change.js', { id: existingGift.key, quantity: 0 })
          : Promise.resolve();

        removeExisting
          .then(function () {
            return window.CartGiftController.queueMutation('/cart/add.js', {
              items: [
                {
                  id: sec.selectedVariantId,
                  quantity: 1,
                  properties: { _free_gift: sec.sectionId },
                },
              ],
            });
          })
          .then(function () {
            sec.busy = false;
            showMessage('Free gift added to your cart!');
            // render() runs automatically off the controller's broadcast —
            // no manual refresh needed.
          })
          .catch(function () {
            sec.busy = false;
            showMessage('Something went wrong. Please try again.', true);
            sec.addBtn.disabled = false;
            sec.addBtn.textContent = sec.defaultLabel;
          });
      });

      // registerTier lets this instance compete on equal footing with
      // every other Free Gift tier AND the Mystery Gift selector for
      // which one is "current"; registerRule is what actually gets
      // render()/evaluate() called on every cart update.
      window.CartGiftController.registerTier({
        id: sec.sectionId,
        min: sec.minCartValueCents,
        max: sec.maxCartValueCents,
        hasGift: function (cart) { return ownGiftLine(sec, cart); },
      });
      window.CartGiftController.registerRule({ render: render, evaluate: evaluate });
    }

    wrapperEls.forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
